import { h, Component } from "preact";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import { loadGAuth } from "../../../../utils/google-auth";

export class GoogleSheetsExport extends Component {
  constructor(props) {
    super(props);
    loadGAuth();
    this.state = {
      creatingSheet: false,
    };
  }
  createGoogleSheet() {
    this.setState({ creatingSheet: true });
    gapi.client.load("sheets", "v4", () => {
      gapi.client.sheets.spreadsheets
        .create({
          properties: {
            title: `Happiness Export of ${
              this.props.currentOverviewUser.first_name
            } ${new Date().toLocaleDateString()}`,
          },
        })
        .then(response => {
          let values = this.props.happinessData.data.map(entry => [
            entry.rating,
            entry.description,
            entry.date,
          ]);
          gapi.client.sheets.spreadsheets.values
            .append({
              spreadsheetId: response.result["spreadsheetId"],
              range: "Sheet1",
              insertDataOption: "INSERT_ROWS",
              valueInputOption: "USER_ENTERED",
              resource: {
                values: [["Rating", "Description", "Date"]].concat(values),
              },
            })
            .then(response => {
              this.setState({ creatingSheet: false });
              toast("Export created on Google Drive");
              window.open(
                `https://docs.google.com/spreadsheets/d/${
                  response.result["spreadsheetId"]
                }`
              );
            })
            .catch(error => {
              this.setState({ creatingSheet: false });
              toast("Something went wrong");
              console.error(error);
            });
        })
        .catch(error => {
          this.setState({ creatingSheet: false });
          toast("Something went wrong");
          console.error(error);
        });
    });
  }
  render() {
    return (
      <Button
        loading={this.state.creatingSheet}
        disabled={this.state.creatingSheet}
        onClick={() => this.createGoogleSheet()}
      >
        <Icon name="external alternate" />
        Export to Google Sheets
      </Button>
    );
  }
}

export default GoogleSheetsExport;



// WEBPACK FOOTER //
// ./src/modules/diary/components/google-sheets/GoogleSheetsExport.js